export default __webpack_public_path__ + "static/media/misc-pantry3-480w.40d08973.avif";